<div class="video_properties">
  <mat-label>
    <mat-icon>video</mat-icon>
    <br/>
    <br/>
  </mat-label>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <br/>
      <br/>
      <br/>
      <br/>
      <button style="margin: 8px" (click)="openCors()" mat-flat-button>
        <mat-icon>lightbulb</mat-icon>
        {{ 'general.importantNotes' | transloco }}
      </button>
      <br/>
    </div>
  }
</div>
